import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
} from "@mui/material";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import oneImage from "../../../assets/Images/01.png";
import HowItWorksImage from "../../../assets/Images/HowItWorks.png";
import "../../../App.css";
import { isMobile } from "react-device-detect";

const HowItWorks = () => {
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };
  return (
    <div
      className="how-it-works-container mt-10 pt-16"
      style={{ paddingBottom: "60px" }}
    >
      <Typography
        style={{
          fontWeight: "600",
          fontSize: "32px",
          lineHeight: "24px",
          width: "100%",
          marginLeft: "5%",
          color: "#222222",
          marginTop: "30px",
          marginBottom: "50px",
        }}
      >
        How it works?
      </Typography>
      <Grid container spacing={6}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={isMobile ? { marginLeft: "20px" } : { marginLeft: "4%" }}
        >
          <List style={isMobile ? { width: "100%" } : null}>
            <ListItem>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "900",
                    fontSize: "60px",
                    lineHeight: "48px",
                  }}
                >
                  01
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Post Request"
                secondary="Post your request by entering simple details about the services you need and post it."
              />
            </ListItem>
            {/* <Divider
              variant="inset"
              component="li"
              style={{ borderTop: "1px solid white" }}
            /> */}
            <ListItem>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "900",
                    fontSize: "60px",
                    lineHeight: "48px",
                  }}
                >
                  02
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Receive Quotes"
                secondary="Receive bids from our experts within few minutes and evaluate their offers."
              />
            </ListItem>
            {/* <Divider
              variant="inset"
              component="li"
              style={{ borderTop: "1px solid white" }}
            /> */}
            <ListItem>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "900",
                    fontSize: "60px",
                    lineHeight: "48px",
                  }}
                >
                  03
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Hire Experts"
                secondary="Select your favorite expert and create work contract with them."
              />
            </ListItem>
          </List>
        </Grid>
        <Grid
          item
          // style={
          //   isMobile
          //     ? {
          //         backgroundImage: `url(${HowItWorksImage})`,
          //         width: "100%",
          //         borderRadius: "10px",
          //         backgroundRepeat: "no-repeat",
          //         height: "300px",
          //         backgroundSize: "contain",
          //       }
          //     : {
          //         backgroundImage: `url(${HowItWorksImage})`,
          //         width: "35%",
          //         borderRadius: "10px",
          //         backgroundRepeat: "no-repeat",
          //       }
          // }
        >
          <div
            style={{
              width: "640px",
              height: "360px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              backgroundImage: isHovering
                ? `linear-gradient(0deg, rgba(255, 109, 28, 0.36), rgba(255, 109, 28, 0.36)),url(${HowItWorksImage})`
                : `url(${HowItWorksImage})`,
              borderRadius: "10px",
              backgroundRepeat: "no-repeat",
            }}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseOut}
          >
            <Button
              variant="outlined"
              size="small"
              style={{
                textTransform: "capitalize",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "24px",
                color: "white",
                borderColor: "white",
                padding: "12px 24px",
              }}
            >
              Play Video
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default HowItWorks;
